import { equipmentType } from './common'

// 禁止IOS橡皮筋效果
export const banIOSRubberBand = function () {
  if (equipmentType() !== 'ios') return false
  // const appDom = document.getElementById('app') as HTMLElement
  // appDom.addEventListener(
  //   'touchmove',
  //   function (e) {
  //     const scrollHeight = appDom.scrollHeight
  //     const scrollTop = this.scrollTop
  //     if (scrollTop < 0 || scrollTop > scrollHeight) {
  //       e.preventDefault()
  //     }
  //   },
  //   { passive: false }
  // )
}
